// 利用a标签下载
import {Message} from "element-ui";
import {renderAsync} from "docx-preview";

export function downloadCommon(url){
    const elink = document.createElement('a')
    elink.href = url
    document.body.appendChild(elink)
    elink.click()
    document.body.removeChild(elink);
}
export function fileDownload(data, name,isPrint = false) {
    if(!data){
        return
    }
    const blob = new Blob([data], {type: data.type});
    if(isPrint){
        handlePrint(blob).then(r => {})
    }else{
        const downloadElement = document.createElement('a');
        // 创建下载链接
        const href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载文件名
        if (name === undefined) {
            name = data.fileName
        }
        downloadElement.download = decodeURI(name)
        document.body.appendChild(downloadElement);
        downloadElement.click();
        // 移除元素
        document.body.removeChild(downloadElement);
        // 释放blob对象
        window.URL.revokeObjectURL(href);
    }
}

function printImage(blob) {
    return URL.createObjectURL(blob);
}
export async function printWord(blob, fileName = "document") {
    if (!blob || !blob.type.includes("wordprocessingml")) {
        console.error("无效的 DOCX 文件");
        return;
    }
    // 创建打印容器
    const printContainer = document.createElement("div");
    printContainer.id = "docx-print-container";
    printContainer.style.position = "fixed";
    printContainer.style.left = "-9999px";
    document.body.appendChild(printContainer);
    try {
        await renderAsync(
            await blob.arrayBuffer(),
            printContainer,
            null,
            {
                className: "docx", // 默认和文档样式类的类名/前缀
                inWrapper: false, // 禁用围绕文档内容渲染包装器
                ignoreWidth: false, // 禁止页面渲染宽度
                ignoreHeight: false, // 禁止页面渲染高度
                ignoreFonts: true, // 禁止字体渲染
                breakPages: true, // 在分页符上启用分页
                ignoreLastRenderedPageBreak: true,//禁用lastRenderedPageBreak元素的分页
                experimental: false, //启用实验性功能（制表符停止计算）
                trimXmlDeclaration: true, //如果为真，xml声明将在解析之前从xml文档中删除
                debug: false, // 启用额外的日志记录
            }
        );
        return printContainer.innerHTML
    } catch (error) {
        console.error("打印失败:", error);
        document.body.removeChild(printContainer);
    }
}
async function printText(blob) {
    const text = await blob.text();
    return  `
    <pre style="
      white-space: pre-wrap;
      font-family: monospace;
      margin: 20px;
      padding: 10px;
      border: 1px solid #eee;
    ">${text}</pre>
  `;
}
function openPrintWindow(htmlContent,type) {
    // 创建隐藏的 iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    if(type){
        // 页面不展示 iframe
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        iframe.src = htmlContent;
        setTimeout(() => {
            //定时器保证iframe先插入页面
            iframe.contentWindow.print();
        }, 100);
    }else{
        document.body.appendChild(iframe);
        // 写入打印内容
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(`
            <body>${htmlContent}</body>
        `);
        doc.close();

        // 打印后自动移除 iframe
        iframe.contentWindow.onload = () => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
    }
}
async function handlePrint(blob) {
    try {
        let content;
        const type = blob.type;
        switch(true) {
            case type.startsWith('image/'):
                content = printImage(blob);
                break;
            case type === 'application/pdf':
                content = printImage(blob);
                break;
            case type.includes('wordprocessingml'):
                content = await printWord(blob);
                break
            case type === 'text/plain':
                content = await printText(blob);
                break;
            default:
                Message.error('不支持的文件类型');
                return
        }
        if(type === 'application/pdf' || type.startsWith('image/')){
            openPrintWindow(content,true);
        }else{
            openPrintWindow(content,false);
        }
    } catch (error) {
        console.log(error);
    }
}

